/* MIONA Groessen-Dropdown (nach Generation gruppiert).
   Re-render-fest: das Theme ersetzt bei Variantenwechsel das Formular-DOM. Deshalb liegt die
   Logik global (Delegation), die gewaehlte Generation kommt in sessionStorage und wird nach
   jedem Neu-Rendern wiederhergestellt (Label, Chip-Markierung, properties[Generation]). */
(function () {
  if (window.__mionaSizePickerInit) return;
  window.__mionaSizePickerInit = true;

  function storeKey(wrap) { return 'miona-gen-' + (wrap.getAttribute('data-product') || 'x'); }

  function chipSize(wrap, targetId, gen) {
    var found = null;
    wrap.querySelectorAll('.miona-size-dd__chip').forEach(function (c) {
      if (c.getAttribute('data-target') === targetId && c.getAttribute('data-gen') === gen) {
        found = c.getAttribute('data-size');
      }
    });
    return found;
  }

  function setActive(wrap, targetId, gen) {
    wrap.querySelectorAll('.miona-size-dd__chip').forEach(function (c) {
      var on = (c.getAttribute('data-target') === targetId && c.getAttribute('data-gen') === gen);
      if (on && !c.classList.contains('is-active')) c.classList.add('is-active');
      if (!on && c.classList.contains('is-active')) c.classList.remove('is-active');
    });
  }

  function setLabel(wrap, text) {
    var v = wrap.querySelector('.miona-size-dd__value');
    if (!v) return;
    if (v.textContent.trim() !== text) v.textContent = text;
    if (!v.classList.contains('is-set')) v.classList.add('is-set');
  }

  function setHidden(wrap, gen, size) {
    var h = wrap.querySelector('input[name="properties[Generation]"]');
    // Leere Felder abschalten, sonst steht in der Bestellung eine Zeile ohne Wert.
    if (h) { h.value = gen || ''; h.disabled = !gen; }
    // Die gewaehlte Smart-Ring-Groesse mitgeben, sonst steht im Warenkorb nur
    // die MIONA-Groesse, die die Kundin nie eingegeben hat.
    var s = wrap.querySelector('input[name="properties[Smart-Ring-Größe]"]');
    if (s) { s.value = size ? String(size) : ''; s.disabled = !size; }
  }

  // Zustand nach (Neu-)Rendern wiederherstellen
  function apply(wrap) {
    var gen = sessionStorage.getItem(storeKey(wrap));
    var checked = wrap.querySelector('.miona-size-dd__inputs input:checked');
    if (!gen || !checked) return;
    var size = chipSize(wrap, checked.id, gen);
    if (!size) return;
    setActive(wrap, checked.id, gen);
    setHidden(wrap, gen, size);
    setLabel(wrap, 'Smart-Ring-Größe ' + size + ' · Generation ' + gen);
  }

  function applyAll() { document.querySelectorAll('.miona-size-dd').forEach(apply); }

  document.addEventListener('click', function (e) {
    var closest = e.target.closest ? e.target.closest.bind(e.target) : function () { return null; };

    var chip = closest('.miona-size-dd__chip');
    if (chip) {
      var wrap = chip.closest('.miona-size-dd');
      var gen = chip.getAttribute('data-gen');
      var size = chip.getAttribute('data-size');
      sessionStorage.setItem(storeKey(wrap), gen);
      setActive(wrap, chip.getAttribute('data-target'), gen);
      setHidden(wrap, gen, size);
      setLabel(wrap, 'Smart-Ring-Größe ' + size + ' · Generation ' + gen);
      var radio = document.getElementById(chip.getAttribute('data-target'));
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      var t = wrap.querySelector('.miona-size-dd__toggle');
      var p = wrap.querySelector('.miona-size-dd__panel');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
      return;
    }

    var toggle = closest('.miona-size-dd__toggle');
    if (toggle) {
      var w2 = toggle.closest('.miona-size-dd');
      var panel = w2.querySelector('.miona-size-dd__panel');
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
      return;
    }

    if (!closest('.miona-size-dd')) {
      document.querySelectorAll('.miona-size-dd').forEach(function (w) {
        var tt = w.querySelector('.miona-size-dd__toggle');
        var pp = w.querySelector('.miona-size-dd__panel');
        if (tt) tt.setAttribute('aria-expanded', 'false');
        if (pp) pp.hidden = true;
      });
    }
  });

  // Nach Formular-Neu-Rendern (async, teils mehrfach) erneut anwenden: gestaffelt statt einmalig.
  function reapplyBurst() {
    [0, 120, 300, 600, 1000, 1500].forEach(function (ms) { setTimeout(applyAll, ms); });
  }

  // Jeder Variantenwechsel (Farbe/Diamant/Groesse) loest ein Re-Render aus -> danach wiederherstellen.
  document.addEventListener('change', function () { reapplyBurst(); }, true);

  // Zusaetzlich: DOM-Aenderungen beobachten (Fallback).
  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    var raf = window.requestAnimationFrame || function (f) { setTimeout(f, 16); };
    raf(function () { scheduled = false; applyAll(); });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') applyAll();
  else document.addEventListener('DOMContentLoaded', applyAll);
})();
